import styled from "styled-components";

export const QuotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
